function filterAnswers(answers, sortBy) {
  return answers.filter(function (answer) {
    return answer.color === sortBy;
  });
}

export default {
  filterAnswers,
};
